export const SKIP_2FA_CHECK_FLAG = 'skip2faCheck';

export const hasSkip2faCheck = (featureFlags: Record<string, unknown> | null | undefined): boolean =>
    Boolean(featureFlags?.[SKIP_2FA_CHECK_FLAG]);
